// Axios
import axiosInstance from '../axios/axiosInstance';

const postSaidaProduct = async (data) => {
  try {
    const res = await axiosInstance.post('saidaProdutos/', data);
    return res.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};
const getSaidaProduto = async () => {
  try {
    const res = await axiosInstance.get('saidaProdutos/');
    return res.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};

const postSaidaNaoRegistrada = async (data) => {
  try {
    const res = await axiosInstance.post('produto/saida/nao_registrada/', data);
    return res.data;
  } catch (error) {
    return { errors: error.response.data };
  }
};

const saidaProduto = {
  postSaidaProduct,
  getSaidaProduto,
  postSaidaNaoRegistrada,
};

export default saidaProduto;
